import React from 'react'
import PropTypes from 'prop-types'
import {AuditPaneContext} from '../../../context/AuditPane'
import Tabs from '../../AuditExpanded/Tabs'
import Tab from '../../AuditExpanded/Tab'
import TabPanel from '../../AuditExpanded/TabPanel'
import GroupTabPanels from '../GroupTabPanels'

function GroupTabs({data}) {
  const paneState = React.useContext(AuditPaneContext)
  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const tabPanelClass = paneState.isExpandOpen ? 'audit-expand__section' : 'audit-expand__Detail'

  return (
    <div
      className={paneState.isExpandOpen ? 'audit-expand__column audit--border-radius' : undefined}
    >
      <Tabs value={value} onChange={handleChange} classes={{root: 'audit-expand__tabs'}}>
        {data.map((entitie, index) => (
          <Tab
            index={index}
            key={index}
            label={entitie.entity_name}
            classes={{root: 'audit-preview__tab--group'}}
          />
        ))}
      </Tabs>
      <div className="p-2">
        {data.map((entitie, index) => (
          <TabPanel value={value} index={index} key={index} className={tabPanelClass}>
            <GroupTabPanels data={entitie} />
          </TabPanel>
        ))}
      </div>
    </div>
  )
}

GroupTabs.propTypes = {
  data: PropTypes.shape({}).isRequired,
}

GroupTabs.displayName = 'GroupTabs'

export default GroupTabs
